import { ActionType, Router as JazzRouter, Routes, useError } from "@cdv/jazz-ui";
import { Stack, Typography } from "@mui/material";
import { ReactElement, useEffect } from "react";
import { useRouteError } from "react-router";
import Layout from "./Layout";
import Outlet from "./Outlet";
import { Resource } from "../utils";
import { useSync } from "./Sync";

const RouterError = (): ReactElement => {
  const error = useRouteError() as Error | undefined;
  const { setError } = useError();
  useEffect(() => {
    if (error) {
      setError(error);
    }
  }, [error]);
  return (
    <Stack
      direction={"column"}
      spacing={1}
      sx={{ width: "100%", height: "100vh", alignItems: "center", justifyContent: "center" }}
    >
      <Typography variant="h1">404</Typography>
      <Typography variant="h2">Stránka nenalezena</Typography>
    </Stack>
  );
};

export default function Router(): ReactElement {
  return (
    <JazzRouter error={<RouterError />} layout={<Layout />} outlet={<Outlet />}>
      <Routes resource={Resource.Page} path="/" />
      <Routes resource={Resource.Game} path="/hra" />
      <Routes resource={Resource.GameAnt} path="/hra/mravenci" />
      <Routes resource={Resource.User} path="/nastaveni" />
      <Routes resource={Resource.Audio} path="/audio" />
      <Routes
        resource={Resource.TestDefinition}
        path="/test"
        only={[ActionType.SHOW, ActionType.INDEX]}
      />
      <Routes resource={Resource.TestVersion} path="/test/verze" only={[ActionType.SHOW]} />
      <Routes resource={Resource.Info} path="/info" only={[ActionType.SHOW, ActionType.INDEX]} />
    </JazzRouter>
  );
}
